import { useFormikContext } from "formik";
import { useEffect } from "react";
import { AkaAdvicePriceFormValues } from "../AkaAdviceCards/interfaces";

export const useResetAdviceDiffConsentIfChangesInForm = (): void => {
  const { values, setFieldValue } =
    useFormikContext<AkaAdvicePriceFormValues>();
  const {
    disabilityInsuredSumCheckbox,
    disabilityInsuredSumSlider,
    disabilityOneTimePaymentCheckbox,
    deathInsuredSumCheckbox,
    deathInsuredSumSlider,
    criticalIllnessInsuredSumCheckbox,
    criticalIllnessInsuredSumSlider,
  } = values;

  useEffect(() => {
    setFieldValue("adviceDiffConsent", false);
  }, [
    disabilityInsuredSumCheckbox,
    disabilityInsuredSumSlider,
    disabilityOneTimePaymentCheckbox,
    deathInsuredSumCheckbox,
    deathInsuredSumSlider,
    criticalIllnessInsuredSumCheckbox,
    criticalIllnessInsuredSumSlider,
  ]);
};
